import { localStorageGet, LocalStorageKeys, localStorageSet } from 'js/src/libs/local-storage';

/**
 * Email capture placements are remembered by id, so a visitor who signs up (or
 * dismisses) in one place isn't asked again there on a later visit.
 */
export function hasDismissedEmailCapture(placementId: string): boolean {
    return (localStorageGet(LocalStorageKeys.EMAIL_CAPTURE_DISMISSED) ?? []).includes(placementId);
}

export function markEmailCaptureDismissed(placementId: string): void {
    const dismissed = localStorageGet(LocalStorageKeys.EMAIL_CAPTURE_DISMISSED) ?? [];
    if (dismissed.includes(placementId)) {
        return;
    }
    localStorageSet(LocalStorageKeys.EMAIL_CAPTURE_DISMISSED, [...dismissed, placementId]);
}
